import * as React from 'react';
const SvgCloudWithFiles = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={276}
    height={240}
    fill="none"
    viewBox="0 0 276 240"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M24 0h240v240H24z" />
    <path
      fill="#E9F2FF"
      d="M144 204c46.392 0 84-37.608 84-84s-37.608-84-84-84-84 37.608-84 84 37.608 84 84 84"
    />
    <path
      fill="#59F"
      fillRule="evenodd"
      d="M199 172c24.853 0 45-20.147 45-45 0-19.771-12.751-36.564-30.477-42.605C209.785 54.849 184.561 32 154 32c-22.412 0-41.954 12.288-52.256 30.495C131.223 66.294 154 91.487 154 122h-10c0-26.48-20.585-48.152-46.625-49.888A51 51 0 0 0 94 72c-27.614 0-50 22.386-50 50s22.386 50 50 50z"
      clipRule="evenodd"
    />
    <path
      fill="#CDF"
      fillRule="evenodd"
      d="M211.5 195.398a1.9 1.9 0 0 0 1.904-1.898 1.9 1.9 0 0 0-1.904-1.898 1.9 1.9 0 0 0-1.904 1.898c0 1.042.847 1.898 1.904 1.898m0 2.602a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M203.5 33.398a1.9 1.9 0 0 0 1.904-1.898 1.9 1.9 0 0 0-1.904-1.898 1.9 1.9 0 0 0-1.904 1.898c0 1.042.847 1.898 1.904 1.898m0 2.602a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
      clipRule="evenodd"
    />
    <path
      fill="#59F"
      d="M107.009 23.568c.504-2.09 3.478-2.09 3.982 0l.765 3.166c.18.747.763 1.33 1.51 1.51l3.166.765c2.091.504 2.091 3.478 0 3.982l-3.166.765c-.747.18-1.33.763-1.51 1.51l-.765 3.166c-.504 2.09-3.478 2.09-3.982 0l-.765-3.166a2.05 2.05 0 0 0-1.51-1.51l-3.166-.765c-2.09-.504-2.09-3.478 0-3.982l3.166-.765a2.05 2.05 0 0 0 1.51-1.51zM160.896 215.655c.534-2.207 3.674-2.207 4.208 0l.712 2.941a2.17 2.17 0 0 0 1.598 1.595l2.928.705c2.211.532 2.211 3.676 0 4.208l-2.928.705c-.79.19-1.407.806-1.598 1.595l-.712 2.941c-.534 2.207-3.674 2.207-4.208 0l-.712-2.941a2.17 2.17 0 0 0-1.597-1.595l-2.929-.705c-2.211-.532-2.211-3.676 0-4.208l2.929-.705a2.17 2.17 0 0 0 1.597-1.595z"
    />
    <path
      fill="#8BF"
      d="M82.514 201.578c-.338-1.343.908-2.546 2.242-2.166l7.337 2.09c1.334.38 1.756 2.058.759 3.021l-5.482 5.294c-.997.962-2.664.487-3.002-.855z"
    />
    <g filter="url(#a)">
      <path
        fill="#fff"
        d="M220.571 102A127.8 127.8 0 0 0 264 113.732c-2.033 4.764-16.48 28.614-59.365 48.266-1.159.18-27.939-12.379-42.635-20.991.499.719 45.649-16.029 58.571-39.007"
      />
    </g>
    <path
      fill="currentColor"
      fillOpacity={0.32}
      d="M219.514 113.857a2.44 2.44 0 0 1 2.152-.321l23.94 7.808c.856.279 1.161 1.344.584 2.042a1.74 1.74 0 0 1-1.909.54l-24.549-8.477c-.692-.239-.82-1.171-.218-1.592M212.812 120.283a2.24 2.24 0 0 1 2.264-.498l16.575 5.623c.73.248.986 1.157.496 1.757-.4.49-1.058.679-1.653.475l-17.386-5.968a.832.832 0 0 1-.296-1.389M205.925 125.618a2.3 2.3 0 0 1 2.244-.374l19.092 6.995c.748.274.972 1.232.425 1.817a1.51 1.51 0 0 1-1.631.388l-19.894-7.36a.856.856 0 0 1-.236-1.466M190.427 136.291a2.105 2.105 0 0 1 2.325-.564l10.913 4.198c.669.257.909 1.088.483 1.67a1.48 1.48 0 0 1-1.734.509l-11.695-4.567a.78.78 0 0 1-.292-1.246M197.549 130.591a2.44 2.44 0 0 1 2.154-.229l25.138 9.265c.802.296.996 1.352.351 1.92a1.53 1.53 0 0 1-1.549.288l-25.929-9.629c-.699-.259-.796-1.216-.165-1.615"
    />
    <g filter="url(#b)">
      <path
        fill="#fff"
        d="M59.687 76a143.6 143.6 0 0 1-47.686 12.514c2.232 5.082 18.095 30.522 65.184 51.484 1.273.192 30.678-13.204 46.816-22.391-.549.767-50.125-17.097-64.314-41.607"
      />
    </g>
    <path
      fill="currentColor"
      fillOpacity={0.32}
      d="M60.849 88.648a2.74 2.74 0 0 0-2.363-.343l-26.288 8.328a1.357 1.357 0 0 0-.64 2.179c.51.599 1.343.828 2.095.576l26.957-9.042c.76-.255.9-1.25.239-1.699M60.393 98.903a2.52 2.52 0 0 0-2.486-.532l-18.2 5.999a1.173 1.173 0 0 0-.545 1.874c.44.522 1.162.724 1.816.506l19.09-6.365a.877.877 0 0 0 .325-1.482M70.159 103.982a2.59 2.59 0 0 0-2.465-.399l-20.963 7.461a1.18 1.18 0 0 0-.467 1.938c.459.477 1.163.64 1.79.414l21.846-7.85a.901.901 0 0 0 .258-1.564M77.487 119.379a2.36 2.36 0 0 0-2.554-.601l-11.982 4.477a1.155 1.155 0 0 0-.53 1.781 1.655 1.655 0 0 0 1.904.543l12.841-4.871a.82.82 0 0 0 .32-1.329M84.734 107.347a2.75 2.75 0 0 0-2.365-.244l-27.603 9.883a1.199 1.199 0 0 0-.386 2.047c.468.4 1.12.518 1.702.308l28.471-10.271a.957.957 0 0 0 .181-1.723"
    />
    <defs>
      <filter
        id="a"
        width={126}
        height={84}
        x={150}
        y={98}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0313726 0 0 0 0 0.12549 0 0 0 0 0.25098 0 0 0 0.32 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2_96" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={8} />
        <feGaussianBlur stdDeviation={6} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0313726 0 0 0 0 0.12549 0 0 0 0 0.25098 0 0 0 0.16 0" />
        <feBlend
          in2="effect1_dropShadow_2_96"
          result="effect2_dropShadow_2_96"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_2_96"
          result="shape"
        />
      </filter>
      <filter
        id="b"
        width={136}
        height={88}
        x={0.001}
        y={72}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0313726 0 0 0 0 0.12549 0 0 0 0 0.25098 0 0 0 0.32 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2_96" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={8} />
        <feGaussianBlur stdDeviation={6} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0313726 0 0 0 0 0.12549 0 0 0 0 0.25098 0 0 0 0.16 0" />
        <feBlend
          in2="effect1_dropShadow_2_96"
          result="effect2_dropShadow_2_96"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_2_96"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgCloudWithFiles;
